(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const form = document.getElementById('cart-form');
    if (!form) return;

    // Handle quantity button clicks
    form.querySelectorAll('[data-qty-change]').forEach(btn => {
      btn.addEventListener('click', function() {
        const change = parseInt(this.dataset.qtyChange);
        const line = this.dataset.line;
        const input = form.querySelector(`input[data-line="${line}"]`);
        
        if (input) {
          const newValue = Math.max(0, parseInt(input.value) + change);
          input.value = newValue;
          
          // Auto-submit the form when quantity changes
          updateCart();
        }
      });
    });

    // Handle direct input changes
    form.querySelectorAll('.elvee-cart__qty-input').forEach(input => {
      input.addEventListener('change', function() {
        updateCart();
      });
    });

    function updateCart() {
      // Collect all quantities
      const inputs = form.querySelectorAll('.elvee-cart__qty-input');
      const updates = {};
      
      inputs.forEach(input => {
        const line = input.dataset.line;
        updates[line] = parseInt(input.value) || 0;
      });

      // Submit via AJAX
      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ updates: Object.values(updates) })
      })
      .then(response => response.json())
      .then(cart => {
        // Reload the page to show updated cart
        window.location.reload();
      })
      .catch(error => {
        console.error('Error updating cart:', error);
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elvee-benefits"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const section = document.querySelector('[data-benefits-section]');
    if (!section) return;

    const items = Array.from(section.querySelectorAll('[data-benefit-item]'));
    
    // Sort items by Z-order (1, 2, 3, 4 = top-left, top-right, bottom-left, bottom-right)
    items.sort((a, b) => {
      return parseInt(a.dataset.zOrder) - parseInt(b.dataset.zOrder);
    });

    let currentIndex = 0;
    let sectionTop = 0;
    let sectionHeight = 0;
    let isAnimating = false;

    function updateSectionBounds() {
      const rect = section.getBoundingClientRect();
      sectionTop = window.scrollY + rect.top;
      sectionHeight = rect.height;
    }

    function handleScroll() {
      if (currentIndex >= items.length) return;

      const scrollY = window.scrollY;
      const windowHeight = window.innerHeight;
      
      // Start animation when section enters bottom of viewport
      const sectionStart = sectionTop - windowHeight;
      // Complete by the time section is 30% visible
      const sectionEnd = sectionTop - windowHeight * 0.3;
      const scrollRange = sectionEnd - sectionStart;
      
      // Calculate which item should be visible based on scroll progress
      const scrollProgress = Math.max(0, (scrollY - sectionStart) / scrollRange);
      const targetIndex = Math.min(Math.floor(scrollProgress * items.length), items.length - 1);

      // Reveal items up to the target index
      for (let i = 0; i <= targetIndex; i++) {
        const item = items[i];
        if (!item.classList.contains('is-visible')) {
          item.classList.add('is-visible');
        }
      }
      
      if (targetIndex >= items.length - 1) {
        currentIndex = items.length;
      }
    }

    // Initial setup
    updateSectionBounds();
    
    // Listen for scroll
    window.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('resize', updateSectionBounds, { passive: true });
    
    // Check initial state
    handleScroll();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elvee-hero"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const carousel = document.querySelector('.elvee-hero__carousel');
    if (!carousel) return;
    
    const slides = carousel.querySelectorAll('.elvee-hero__slide');
    // Only start carousel if there are multiple slides
    if (slides.length <= 1) return;
    
    // Find the initially active slide
    let current = Array.from(slides).findIndex(slide => slide.classList.contains('active'));
    if (current === -1) current = 0;
    
    const interval = 5000; // 5 seconds
    
    function nextSlide() {
      slides[current].classList.remove('active');
      current = (current + 1) % slides.length;
      slides[current].classList.add('active');
    }
    
    setInterval(nextSlide, interval);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  // Mobile menu toggle
  const toggle = document.querySelector('.elvee-header__toggle');
  const mobileNav = document.querySelector('.elvee-header__mobile-nav');
  const openIcon = document.querySelector('.elvee-header__toggle-open');
  const closeIcon = document.querySelector('.elvee-header__toggle-close');

  if (toggle && mobileNav) {
    toggle.addEventListener('click', function() {
      const isOpen = mobileNav.getAttribute('aria-hidden') === 'false';
      mobileNav.setAttribute('aria-hidden', isOpen ? 'true' : 'false');
      toggle.setAttribute('aria-expanded', !isOpen);
      openIcon.style.display = isOpen ? 'block' : 'none';
      closeIcon.style.display = isOpen ? 'none' : 'block';
    });
  }

  // Scroll detection for header background
  const header = document.querySelector('[data-header]');
  const scrollThreshold = 50;

  if (header) {
    function updateHeader() {
      if (window.scrollY > scrollThreshold) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }
    }

    window.addEventListener('scroll', updateHeader, { passive: true });
    updateHeader(); // Check initial state
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
  // Purchase option toggle
  document.querySelectorAll('.elvee-pdp__option').forEach(option => {
    option.addEventListener('click', function() {
      document.querySelectorAll('.elvee-pdp__option').forEach(o => o.classList.remove('elvee-pdp__option--active'));
      this.classList.add('elvee-pdp__option--active');
      this.querySelector('input').checked = true;

      const frequency = document.querySelector('.elvee-pdp__frequency');
      if (this.dataset.option === 'subscribe') {
        frequency.style.display = 'block';
      } else {
        frequency.style.display = 'none';
      }
    });
  });

  // Quantity controls
  document.querySelectorAll('.elvee-pdp__qty-btn').forEach(btn => {
    btn.addEventListener('click', function() {
      const input = document.querySelector('.elvee-pdp__qty-input');
      let value = parseInt(input.value);
      if (this.dataset.action === 'increase' && value < 10) {
        input.value = value + 1;
      } else if (this.dataset.action === 'decrease' && value > 1) {
        input.value = value - 1;
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
